export enum ThirdPartyName {
    caro = 'caro',
    cloudPat = 'cloudPat',
    dgtlHealth = 'dgtlHealth',
    ectosense = 'ectosense',
    embloomQuestionnaire = 'embloomQuestionnaire',
    evidencio = 'evidencio',
    fysiologic = 'fysiologic',
    healthConnectedFundusManualImport = 'healthConnectedFundusManualImport',
    healthConnectedFundusNisIntegration = 'healthConnectedFundusNisIntegration',
    interapyQuestionnaire = 'interapyQuestionnaire',
    interapyUser = 'interapyUser',
    lime = 'lime',
    nsi = 'nsi',
    optoconnect = 'optoconnect',
    processTask = 'processTask',
    teledia = 'teledia',
    therapielandInvitation = 'therapielandInvitation',
    therapielandUser = 'therapielandUser',
    vipLiveFundusManualImport = 'vipLiveFundusManualImport',
}
